export default class UnhandledException {
  softwareID: number = 0
  repository: string = ""
  subRepository?: string
  application: string = ""
  assemblyName: string = ""
  exceptionMessage: string = ""
  baseExceptionMessage: string = ""
  callStack: string = ""
}
